var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['user-layout-wrapper', _vm.isMobile && 'mobile'],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"contain"},[_c('router-view'),_c('div',{staticClass:"login_back"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }